import { render, staticRenderFns } from "./HowtoSaveBroadcastSearch.vue?vue&type=template&id=4785f56c&"
import script from "./HowtoSaveBroadcastSearch.vue?vue&type=script&lang=js&"
export * from "./HowtoSaveBroadcastSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports